import styled from "styled-components";

export const MenuComplementsContainer = styled.div``